import React, { useState, useEffect } from 'react';
import type { PublicPlayerProps } from '../../types';
import { FlatList, Image, ActivityIndicator } from 'react-native';
import SearchBox from '../../Components/SearchBox';
import { Icons } from '../../Components';
import { ManageCompetitionApi } from '../api';
import moment from 'moment-mini';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type PlayerSelectorProps = {
    onSelectPlayer: (player:PublicPlayerProps) => void,
    onClose: () => void
}

const PlayerSelector = ({ onSelectPlayer, onClose }:PlayerSelectorProps) => {
    const Colors = useColors();
    const [ search_value, setSearchValue ] = useState('');
    const [ selector_data, setData ] = useState<{
        loading:boolean,
        offset:number,
        players:PublicPlayerProps[]
    }>({
        loading: false,
        offset:0,
        players:[]
    })
    const { loading, offset, players } = selector_data;

    useEffect(() => {
        searchPlayers(0)
    },[])

    const searchPlayers = async(offset:number) => {
        setData({ ...selector_data, loading:true })
        const ps = await ManageCompetitionApi.searchPlayers(search_value, offset);
        setData({
            ...selector_data,
            players: ps,
            loading:false,
            offset: offset
        })
    }

    const renderPlayers = (data:{item:PublicPlayerProps, index:number}) => {
        return (
            <Button style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }} onPress={() => onSelectPlayer(data.item)}>
                <Image
                    source={{ uri: data.item.profile_pic && data.item.profile_pic != '' ? data.item.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:40, width:40, borderRadius:4 }}
                    resizeMode="cover"
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme="h2">@{data.item.username}</Text>
                    <Text style={{ marginTop:3 }} theme="description">Joined {moment(data.item.create_datetime).format('MMM YYYY')}</Text>
                </View>
                <Icons.ChevronIcon direction="right" color={Colors.text.h1} size={8} />
            </Button>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <View type='header' style={{ padding:20, flexDirection:'row', alignItems:'center' }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme='h1'>Select Player</Text>
                </View>
            </View>
            <View style={{ flex:1 }}>
                <View type='body' style={{ flex:1 }}>
                    <View style={{ marginTop:0 }}>
                        <SearchBox 
                            onSearch={() => searchPlayers(0)}
                            onChange={(text) => setSearchValue(text)}
                        />
                    </View>
                    {loading ?
                    <ActivityIndicator style={{ padding:20, alignSelf:'center' }} size='large' color={Colors.text.h1} />
                    :<></>}
                    <FlatList
                        data={players}
                        renderItem={renderPlayers}
                        keyExtractor={(item) => item.player_id.toString()}
                    />
                </View>
                <View style={{ padding:10, flexDirection:'row', alignItems:'center', justifyContent:'space-between' }}>
                    {offset > 0 ?
                    <Button
                        title='PREV'
                        type='text'
                        onPress={() =>  searchPlayers(offset - 1)}
                    />
                    :<View/>}
                    <Button
                        title='NEXT'
                        type='text'
                        onPress={() => searchPlayers(offset + 1)}
                    />
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <Button
                    title='CLOSE'
                    style={{ flex:1 }}
                    type='error'
                    onPress={() => onClose()}
                />
            </View>
        </View>
    )
}

export default PlayerSelector